module.exports = __webpack_public_path__ + "static/media/6.bcacfb9f.jpeg";